import Amt from "./amt/Amt";
import BusinessTravelBenefitButton from "./business-travel-benefit-button/BusinessTravelBenefitButton";
import BusinessTravel from "./business-travel/BusinessTravel";
import CorporateGroupTravel from "./corporate-group-travel-protection/CorporateGroupTravel";
import AUBusinessTravel from "./au-business-travel/AUBusinessTravel";
import PortuguesePurchasePath from "./portuguese-purchase-path/PortuguesePurchasePath";

const Container = ({ module, version }: any) => {
  let component = null;
  switch (module) {
    case "business-travel":
      component = <BusinessTravel version={version} />;
      break;
    case "business-travel-benefit-button":
      component = <BusinessTravelBenefitButton version={version} />;
      break;
    case "amt":
      component = <Amt />;
      break;
    case "corporate-group-travel-protection":
      component = <CorporateGroupTravel version={version} />;
      break;
    case "business-travel-plan-quote":
      component = <AUBusinessTravel version={version} />;
      break;
    case "portuguese-purchase-path":
      component = <PortuguesePurchasePath />;
      break;

    default:
      component = <BusinessTravel version={version} />;
      break;
  }
  return <>{component}</>;
};

export default Container;
